//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

export default {
	name: 'LoadMore',
	data() {
		return {}
	},
	computed: {
		...mapGetters(["activeListingCount"]),
	},
	methods: {
		...mapActions(["increaseActiveListingCount"]),
		showMoreListings() {
			this.increaseActiveListingCount(parseInt(this.$root.listingCount));
		}
	},
	mounted() {
		
	}
}
